export const SITE_DEFAULT_LOGO = '/images/placeholder_site_logo.png';
export const SITE_DEFAULT_ASSET_ID = -1;
